"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var CustomerInformationSummaryStyles = makeStyles_1.default(function () { return ({
    item: {},
}); }, { name: 'Checkout4_CustomerInformationSummary' });
exports.default = CustomerInformationSummaryStyles;
